import { Box, Card, Container, Grid, Stack, Typography } from '@mui/material';
import { useScroll } from 'framer-motion';
import ScrollProgress from 'src/components/scroll-progress';
import { useSettingsContext } from 'src/components/settings';
import { useLocales } from 'src/locales';
import HomeIntroToToken from '../home-intro-to-token';
import HomeMonetarySystem from '../home-monetary-system';

function HomeTokenView() {
  const { scrollYProgress } = useScroll();

  const { t } = useLocales();
  const settings = useSettingsContext();

  return (
    <>
      <ScrollProgress scrollYProgress={scrollYProgress} />

      <HomeIntroToToken />

      <HomeMonetarySystem />

      <Container maxWidth="lg">
        <Stack sx={{ py: { xs: 5, md: 10 } }}>
          <Typography variant="h2" color="primary" textTransform="uppercase" align="center">
            {t('walkup_lang_002')}
          </Typography>

          <Stack mt={4}>
            <Box
              component="img"
              src={`./assets/images/home/token-page/tokenomics-pie-chart-${settings.themeMode}.png`}
            />
          </Stack>

          <Stack mt={8}>
            <Typography variant="h5" width="78%" mx="auto" mb={2}>
              {t('walkup_lang_186')}
            </Typography>
            <Box
              component="img"
              src="./assets/images/home/token-page/tokenomics-chart.png"
              width="80%"
              mx="auto"
            />
          </Stack>
        </Stack>
      </Container>

      {/*  */}
      <Container maxWidth="lg">
        <Stack sx={{ py: { xs: 5, md: 10 } }}>
          <Typography variant="h2" color="primary" textTransform="uppercase" align="center">
            {t('walkup_lang_187')}
          </Typography>

          <Stack mt={4}>
            <Box
              component="img"
              src={`./assets/images/home/token-page/token-demand-${settings.themeMode}.png`}
            />
          </Stack>
        </Stack>
      </Container>

      {/*  */}
      <Container maxWidth="lg">
        <Stack sx={{ py: { xs: 5, md: 10 } }}>
          <Typography variant="h2" color="primary" textTransform="uppercase" align="center">
            {t('walkup_lang_187')}
          </Typography>

          <Stack mt={4}>
            <Box
              component="img"
              src={`./assets/images/home/token-page/revenue-devision-${settings.themeMode}.png`}
            />
          </Stack>
        </Stack>
      </Container>
    </>
  );
}

export default HomeTokenView;
